import { HttpClient } from '@angular/common/http';
import {Component, OnDestroy, OnInit, Inject, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';

import {GroupService} from '../../services/group.service';
import {catchError, map, startWith, take, takeUntil, tap} from 'rxjs/operators';

import {Observable, Subject, of, throwError} from 'rxjs';
import { Group } from '../../models/group';
import { AlertDialog, AlertDialogConfig } from '../alert/dialog';
import { RoleService } from '../../services/role.service';
import { Role } from '../../models/role';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Component({
  standalone: false,
  selector: 'app-add-group',
  templateUrl: './add-group-template.html',
  styleUrls: ['./add-group-style.scss'],
})
export class AddGroupComponent implements OnInit, OnDestroy {
  showMoreOptions_ = false;

  isExternal = false;
  groupForm!:  FormGroup;
  readonly nameMaxLength = 24;
  private created_ = false;
  private unsubscribe_ = new Subject<void>();
  rolesListDictionary : Array<any> = [];
  filteredRolesByName!: Observable<any[]> | undefined ;
  selectedOptions: Role[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('autoP', {static: false}) matAutocomplete!: MatAutocomplete ;

  constructor(
    public dialogRef: MatDialogRef<AddGroupComponent>,
    private groupService: GroupService,
    private rolesService:  RoleService,
    private readonly route_: ActivatedRoute,
    private readonly fb_: FormBuilder,
    private readonly dialog_: MatDialog,
    private readonly router_: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  get name(): AbstractControl | null {
    return this.groupForm.get('name');
  }


  ngOnInit(): void {
    this.rolesService.get()
          .subscribe(result => {
            this.rolesListDictionary = result;
          }
          );
    this.groupForm = this.fb_.group({
      name: ['', [Validators.required, ]],
    });

  }

  ngOnDestroy(): void {
    this.unsubscribe_.next();
    this.unsubscribe_.complete();
  }


  hasUnsavedChanges(): boolean {
    return this.groupForm.dirty;
  }

  isCreateDisabled(): boolean {
    return !this.groupForm.valid;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  add(): void {
    const group =  {
      name: (this.name)? this.name.value : null,
    }

    this.groupService.addGroup(group)
    .subscribe( _ => {
      if(!_.status){
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'ajout du groupe : ' + _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
      }else{
        const config = {
          title: 'Ajouté !',
          message: _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
        this.dialogRef.close();
      }
    },
    error => {
      const config = {
        title: 'Erreur',
        message: 'Une erreur est survenue lors de l\'ajout du groupe : ' + error,
        confirmLabel: 'OK'
      } as AlertDialogConfig;
      this.dialog_.open(AlertDialog, {data: config});
      return throwError(error);
    }
    );
  }


  canDeactivate(): boolean {
    return this.groupForm.pristine || this.created_;
  }


}
